import { ImageCard } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Button, SxProps, Theme } from '@mui/material';

import {
  SubCategoryProgressGroup,
  SubCategoryProgressGroupProps,
} from '../atoms/SubCategoryProgressGroup';

const LIFE_READINESS_STRINGS = appStrings.modules.lifeReadiness;

const FIGMA_CARD_HEIGHT = 408;
const FIGMA_CARD_WIDTH = 291;
const FIGMA_IMAGE_CONTAINER_HEIGHT = 200;

export type LifeReadinessCategoryCardProps = Readonly<{
  title: string;
  imageSrc: string;
  description: string;
  progressBars?: SubCategoryProgressGroupProps['progressBars'];
  onClick: () => void;
}>;

export const CategoryCard = ({
  title,
  description,
  imageSrc,
  progressBars,
  onClick,
}: LifeReadinessCategoryCardProps) => {
  const showProgressBars = progressBars && Object.keys(progressBars).length > 0;

  if (!showProgressBars) {
    return (
      <ImageCard
        imageUrl={imageSrc}
        title={title}
        onClick={onClick}
        description={description}
        sxOverrides={{
          container: containerSx,
          imageWrapper: imageWrapperSx,
          image: imageSx,
          titleDescChildContainer: titleDescChildContainerNoProgressSx,
        }}
      >
        <Button
          variant="contained"
          onClick={onClick}
          hierarchy="Primary"
          size="lg"
          fullWidth
          sx={buttonSx}
        >
          {LIFE_READINESS_STRINGS.cta}
        </Button>
      </ImageCard>
    );
  }

  return (
    <ImageCard
      imageUrl={imageSrc}
      title={title}
      onClick={onClick}
      sxOverrides={{
        container: containerSx,
        image: imageSx,
        imageWrapper: imageWrapperSx,
        titleDescChildContainer: titleDescChildContainerWithProgressSx,
      }}
    >
      <SubCategoryProgressGroup progressBars={progressBars} />
    </ImageCard>
  );
};

const buttonSx: SxProps<Theme> = ({ backrs }) => ({
  marginTop: backrs.spacing['spacing-xl'],
});

const containerSx: SxProps<Theme> = {
  width: {
    xs: '100%',
    md: `${FIGMA_CARD_WIDTH}px`,
  },
  minHeight: `${FIGMA_CARD_HEIGHT}px`,
  height: '100%',
  maxWidth: { xs: '100%', md: `${FIGMA_CARD_WIDTH}px` },
};

const imageWrapperSx: SxProps<Theme> = ({ backrs }) => ({
  backgroundColor: backrs.colors['Colors/Foreground/fg-secondary'],
  display: 'flex',
  alignItems: 'center',
  minWidth: {
    xs: '100%',
    sm: `${FIGMA_CARD_WIDTH}px`,
  },
  minHeight: `${FIGMA_IMAGE_CONTAINER_HEIGHT}px`,
  maxHeight: {
    xs: `${FIGMA_IMAGE_CONTAINER_HEIGHT * 1.25}px`,
    sm: `${FIGMA_IMAGE_CONTAINER_HEIGHT}px`,
  },
  justifyContent: 'center',
});

const imageSx: SxProps<Theme> = {
  maxHeight: '160px',
  maxWidth: '220px',
  width: 'auto',
};

const titleDescChildContainerNoProgressSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
};

const titleDescChildContainerWithProgressSx: SxProps<Theme> = {
  height: '100%',
};
